import { Timelapse } from '@mui/icons-material';
import { Checkbox, Dialog, FormControlLabel } from '@mui/material';
import { WidgetHeader, WidgetIcon } from '@procureai/ui-mui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { BUSINESS_LOG_QUERY } from '../../BusinessLogQuery.gql';
import { useMaskedBiddingBusinessLog } from '../../hooks/useMaskedBiddingBusinessLog';
import { BusinessLogItem } from '../BusinessLogItem/BusinessLogItem';
import { BusinessLogMaskedBiddingTooltip } from '../BusinessLogMaskedBiddingTooltip/BusinessLogMaskedBiddingTooltip';
import { TlscpEntityVariant } from '@/generated/gql/graphql';
import { I18nNamespace } from '~/common/types';
import { VirtualList } from '~/components/VirtualList/VirtualList';
import { OpenCloseProps } from '~/hooks';

type BusinessLogPopoverProps = OpenCloseProps & {
  isMaskedBidding?: boolean;
  entityId: string;
  entityVariant: TlscpEntityVariant;
};

export const BusinessLogPopover = ({ entityId, entityVariant, ...dialogProps }: BusinessLogPopoverProps) => {
  const { t } = useTranslation(I18nNamespace.widgets, { keyPrefix: 'BusinessFeedWidget' });
  const [includeChildren, setIncludeChildren] = useState(false);
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIncludeChildren(event.target.checked);
  };

  const { disableQueryChildren, isMaskedNegotiationCaseLog } = useMaskedBiddingBusinessLog({ entityId, entityVariant });

  return (
    <Dialog {...dialogProps}>
      <WidgetHeader
        title={t('title')}
        icon={<WidgetIcon icon={<Timelapse fontSize="small" />} />}
        subTitle={
          <BusinessLogMaskedBiddingTooltip needsTooltip={disableQueryChildren}>
            <FormControlLabel
              control={
                <Checkbox size="small" onChange={onChange} checked={includeChildren} disabled={disableQueryChildren} />
              }
              label={t('includeChildren')}
            />
          </BusinessLogMaskedBiddingTooltip>
        }
      />
      {!isMaskedNegotiationCaseLog && (
        <VirtualList
          itemSize={50}
          query={BUSINESS_LOG_QUERY}
          queryOptions={{
            getNodesRoot: (data) => data?.telescope.logEntries,
            variables: {
              entityId,
              entityVariant,
              limit: 1000,
              includeChildren,
            },
          }}
          renderItem={BusinessLogItem as any}
        />
      )}
    </Dialog>
  );
};
